// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-stack-toggle{z-index:5001}.t-stack-toggle .t-stack-counter{min-width:28px;height:28px}.t-stack-block{z-index:5000;margin-right:0 !important}.t-stack-block .t-stack-body{width:0;height:0;transition:400ms ease}.t-stack-block .t-stack-body.expand{width:25vw;height:80vh}.t-stack-block .t-stack-body.expand.plus{width:50vw}.t-stack-block .t-stack-body .t-stack-header{height:55px}.t-stack-block .t-stack-body .t-stack-content{height:calc(100% - 55px)}", ""]);
// Exports
module.exports = exports;
